module.exports = {
	init: function ($) {
		this.filterClickEvent($)
		this.courseTopicsEvent($)
		this.navPageClickEvent($)
		this.favoritesClickEvent($)
		this.accountClickEvent($)
	},
	accountClickEvent: function ($) {
		$(document).on('click', '#account-submit', function () {
			const user_pass = jQuery('#user_pass').val()
			console.log(user_pass)
			const data = {
				action: 'set_user_data',
				user_pass: user_pass,
			}
			jQuery.ajax({
				url: xto_ajax.ajax_url,
				type: 'post',
				data: data,
				success: function (response) {
					if (response) {
						const result = JSON.parse(response)
						if (result.status) {
							jQuery('#message-submit').html(result.message)
							console.log('AJAX Request Satisfactory: ', result.message)
						} else {
							jQuery('#message-submit').html(result.message)
							console.error('AJAX Request Failed: ', result.message)
						}
					}
				},
				error: function (jqXHR, textStatus, errorThrown) {
					console.error('AJAX Error: ', textStatus, errorThrown)
				},
			})
		})
	},
	favoritesClickEvent: function ($) {
		$(document).on('click', '.favorite', function () {
			const course_id = $(this).data('course')
			let favorite = $(this)
			const data = {
				action: 'set_favorite',
				course_id: course_id,
			}
			$.ajax({
				url: xto_ajax.ajax_url,
				type: 'post',
				data: data,
				success: function (response) {
					if (response) {
						const result = JSON.parse(response)
						if (result.status) {
							if (result.data.active) {
								favorite.addClass('active')
							} else {
								favorite.removeClass('active')
							}
							console.log('AJAX Request Satisfactory: ', result.message)
						} else {
							console.error('AJAX Request Failed: ', result.message)
						}
					}
				},
				error: function (jqXHR, textStatus, errorThrown) {
					console.error('AJAX Error: ', textStatus, errorThrown)
				},
			})
		})
	},
	navPageClickEvent: function ($) {
		let self = this

		$(document).on('click', '.nav-page .link', function () {
			$('.nav-page span.link--bold').addClass('link').removeClass('link--bold')
			$(this).removeClass('link').addClass('link--bold')
			const tab = $(this).data('tab')
			const status = $('.grid-content[data-content="' + tab + '"]').data('status')

			if (status != 'completed') {
				console.log(tab)
				const data = {
					action: 'nav_page_my_courses',
					tab: tab,
				}
				self.nav_page(data)
			} else {
				$('.content-page .grid-content').removeClass('active')
				$('.grid-content[data-content="' + tab + '"]').addClass('active')
			}
		})
	},
	nav_page: function (data) {
		jQuery('.loading').addClass('active')
		jQuery.ajax({
			url: xto_ajax.ajax_url,
			type: 'post',
			data: data,
			success: function (response) {
				if (response) {
					const result = JSON.parse(response)
					if (result.status) {
						jQuery('.grid-content[data-content="' + result.message + '"]').html(
							result.data.content,
						)
						jQuery('.content-page .grid-content').removeClass('active')
						jQuery('.grid-content[data-content="' + result.message + '"]').addClass(
							'active',
						)
						jQuery('.grid-content[data-content="' + result.message + '"]').data(
							'status',
							'completed',
						)
						console.log('AJAX Request Satisfactory: ', result.message)
					} else {
						console.error('AJAX Request Failed: ', result.message)
					}
				}
				jQuery('.loading').removeClass('active')
			},
			error: function (jqXHR, textStatus, errorThrown) {
				console.error('AJAX Error: ', textStatus, errorThrown)
				jQuery('.loading').removeClass('active')
			},
		})
	},
	filterClickEvent: function ($) {
		let self = this

		function filterSelection(category) {
			$('.filter-item').removeClass('selected')
			$('.filter-item[data-slug="' + category + '"]')
				.addClass('selected')
				.removeClass('link')
		}

		function handleCategoryClick() {
			const category = $(this).attr('data-slug')

			if (!category) {
				return
			}

			const data = {
				action: 'filter_categories',
				category: category,
			}

			self.filter_categories(data)
			filterSelection(category)
		}

		$(document).on(
			'click',
			'.filter__content .filter-item, .breadcrumb .filter-item',
			handleCategoryClick,
		)
		$(document).on('click', '.breadcrumb .link', handleCategoryClick)

		function handlePageClick() {
			const category = $(this).attr('data-category')
			const search = $(this).attr('data-search')
			const action = category ? 'filter_categories' : 'pagination_search'
			const page = $(this).attr('data-page')

			const data = {
				action: action,
				page: page,
				category: category,
				search: search,
			}

			self.filter_categories(data)
		}

		$(document).on('click', 'div.page-numbers', handlePageClick)
	},
	filter_categories: function (data) {
		jQuery('.loading').addClass('active')
		jQuery.ajax({
			url: xto_ajax.ajax_url,
			type: 'post',
			data: data,
			success: function (response) {
				if (response) {
					const result = JSON.parse(response)
					if (result.status) {
						console.log('AJAX Request Satisfactory: ', result.message)
						jQuery('.grid-content').html(result.data.content)
						jQuery('.breadcrumb').html(result.data.breadcrumb)
						jQuery('.pagination').html(result.data.pagination)
						jQuery('.main-container').removeClass('page-content')
					} else {
						console.error('AJAX Request Failed: ', result.message)
					}
				}
				jQuery('.loading').removeClass('active')
			},
			error: function (jqXHR, textStatus, errorThrown) {
				console.error('AJAX Error: ', textStatus, errorThrown)
				jQuery('.loading').removeClass('active')
			},
		})
	},
	courseTopicsEvent: function ($) {
		$(document).on('click', '.course-sidebar__course-filter', function (event) {
			event.preventDefault()
			event.stopPropagation()

			const $button = $(this)
			const courseId = $button.data('course-id')
			const courseUrl = $button.data('course-url')
			const $course = $button.closest('.course-sidebar__course')
			const $panel = $course.children('.course-sidebar__panel')
			const $toggle = $course.find('> .course-sidebar__course-header .course-sidebar__toggle')

			if (!courseId) {
				return
			}

			if ($('body').hasClass('single-topics')) {
				if (courseUrl) {
					window.location.href = courseUrl
				}

				return
			}

			if ($panel.length) {
				$course.addClass('is-open')
				$panel.prop('hidden', false)
				$toggle.attr('aria-expanded', 'true')
			}

			$('.course-sidebar__course').removeClass('is-current')
			$course.addClass('is-current')

			$('.loading').addClass('active')

			$.ajax({
				url: xto_ajax.ajax_url,
				type: 'post',
				dataType: 'json',
				data: {
					action: 'filter_course_topics',
					course_id: courseId,
				},
				success: function (response) {
					if (!response || !response.success) {
						return
					}

					if (response.data.breadcrumb) {
						$('.breadcrumb').html(response.data.breadcrumb)
					}

					if (response.data.content) {
						$('.grid-content').html(response.data.content)
					}

					$('.pagination').html(response.data.pagination || '')
				},
				error: function (jqXHR, textStatus, errorThrown) {
					console.error('AJAX Error: ', textStatus, errorThrown)
				},
				complete: function () {
					$('.loading').removeClass('active')
				},
			})
		})
	},
}